/* eslint-disable */

$(document).ready(function() {
  $('.item-cart-remove').click(function () {
      var $input = $(this).parent().find('input.item-cart-field');
      var count = parseInt($input.val()) - 1;
      count = count < 1 ? 1 : count;
      $input.val(count);
      $input.change();
      return false;
  });
  $('.item-cart-add').click(function () {
      var $input = $(this).parent().find('input.item-cart-field');
      $input.val(parseInt($input.val()) + 1);
      $input.change();
      return false;
  });
});
